import * as TFF from '@tff/types/TFF';

const isBaggageIncluded = (value: string | undefined) => {
  return value && /(BI[0-9][0-9])/.test(value);
};

/*
  Configures and forms "ssrsToAdd" state in AncillariesPage.tsx
  fetches already included ssrs from flightDetails and stores them in the state
  if no baggage included, adds a mockup ssr "BA0" to state.
*/

export const formSsrs = (ssrs: TFF.SsrDetails[], pax: TFF.Passenger, flightDetails: TFF.FlightDetails) => {
  const countJourneys = flightDetails.OrderDetails.Journeys.length;
  // Iterate over journeys (outbound and inbound - if exists)
  for (let i = 0; i < countJourneys; i++) {
    let hasBA = false;
    // Iterate over ssrs for pax
    for (let j = 0; j < pax.JourneyExtras?.[i]?.Ssrs?.length!; j++) {
      const ancillaryId = pax.JourneyExtras?.[i]?.Ssrs?.[j]!;
      const ancillary = flightDetails.OrderDetails.Ancillaries?.[ancillaryId];

      if (!ancillary) {
        continue;
      }

      if (ancillary.Value?.startsWith('BA') || isBaggageIncluded(ancillary.Value)) {
        hasBA = true;
      }

      ssrs.push({
        code: ancillary.TfaDetails?.Code ?? ancillary.Value ?? ancillary.Type,
        amount: 1,
        segmentOnd: flightDetails.OrderDetails.Journeys?.[i]?.Ond!,
        price: ancillary.TotalAmount,
        tuiRelated: ancillary.Note === 'ATCOM',
      });
    }

    if (!hasBA) {
      ssrs.push({
        code: 'BA0',
        amount: 1,
        segmentOnd: flightDetails.OrderDetails.Journeys?.[i]?.Ond!,
        tuiRelated: false,
      });
    }
  }
};
